import { schemaMixin, WSchema } from '@witkac/vuetify-components';

/**
 * @vuese
 * @group mixins
 *
 * Mixin formularzy, przyspiesza importowanie `@witkac/vuetify-components`
 */
export const formMixin = {
  mixins: [schemaMixin],
  components: { WSchema }
};
